import { koComponent } from '../ko-utils';

class Pager {
    constructor(params) {
        this.rawMode = params.rawMode;

        this.pageInfo = ko.unwrap(params.pageInfo);
        this.getPageCallback = params.getPage;
        console.log('PAA', this.pageInfo.pagesCount());
        this.currentPage = this.pageInfo.page;

        this.hasPrev = ko.computed(() => {
            return this.currentPage() > 1;
        });

        this.hasNext = ko.computed(() => {
            return this.currentPage() < this.pageInfo.pagesCount();
        });
    }

    getPage(page) {
        this.currentPage(page);

        if (this.getPageCallback) {
            this.getPageCallback(page);
        } else {
            console.error('No getPage handler defined');
        }
    }

    getPrev() {
        if (this.currentPage() > 1) {
            this.getPage(this.currentPage() - 1);
        }
    }

    getNext() {
        if (this.currentPage() < this.pageInfo.pagesCount()) {
            this.getPage(this.currentPage() + 1);
        }
    }
}

export default koComponent('pager', Pager);